import { Route, Routes } from 'react-router'

import { version } from '../../package.json'

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <div>
            <p>App Version: {version}</p>
          </div>
        }
      />
    </Routes>
  )
}

export default AppRoutes
